export default function NotFoundPage({ t, requestedPath }) {
  const nf = t.notFound;

  return (
    <section
      id="not-found"
      data-testid="not-found-page"
      className="bg-white border-b border-[#e2e6ec]"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 text-center">
        <div className="font-mono text-xs uppercase tracking-[0.35em] text-[#e3191b] mb-4">
          {nf.eyebrow}
        </div>
        <h1 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
          {nf.title}
        </h1>
        <p className="mt-6 text-slate-600 leading-relaxed text-base sm:text-lg max-w-xl mx-auto">
          {nf.lead}
        </p>
        <p className="mt-4 font-mono text-xs text-slate-500 break-all max-w-xl mx-auto">
          <span className="text-[#0b378c]">{nf.pathLabel}</span>{" "}
          <span className="text-slate-800">{requestedPath}</span>
        </p>
        <p className="mt-6 text-sm text-slate-500 max-w-lg mx-auto">{nf.hint}</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            data-testid="not-found-home"
            href={nf.homeHref}
            className="inline-flex items-center justify-center gap-2 bg-[#0b378c] hover:bg-[#082a6e] text-white font-bold uppercase tracking-wider text-sm px-8 py-4 transition-colors"
          >
            {nf.backHome}
          </a>
          <a
            href={nf.phoneHref}
            className="inline-flex items-center justify-center gap-2 border-2 border-[#e3191b] text-[#e3191b] hover:bg-[#e3191b] hover:text-white font-bold uppercase tracking-wider text-sm px-8 py-4 transition-colors"
          >
            {nf.callUs}
          </a>
        </div>
      </div>
    </section>
  );
}
